import { Display2 } from '@sainsburys-tech/luna-typography'
import { ITitle } from '../../../types'

const Title = ({ text }: ITitle) => {
  return (
    <div>
      <Display2 id="s-card-title">{text}</Display2>
    </div>
  )
}

export default Title
